var render, staticRenderFns
import script from "./ocean.vue?vue&type=script&lang=js&"
export * from "./ocean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818a5b60",
  null
  
)

export default component.exports